angular.module('tf.directives')

    .directive("tfTooltip",['$tooltip',function($tooltip){
        return {
            restrict: "A",
            scope: {
                tfTooltip : "@",
                tfTooltipOptions : "="
            },
            link: function(scope, element){
                var defaultOptions = {
                    delay : {show : 500, hide : 100},
                    container : 'body'
                };
                $tooltip(element, angular.extend({title: scope.tfTooltip}, defaultOptions, scope.tfTooltipOptions));
            }
        };

    }])
;